module.exports = __webpack_public_path__ + "img/error.b8b8d8c8.svg";